import { createFileRoute, redirect } from "@tanstack/react-router";

// Ausstattung liegt ausschließlich im internen Bereich. Alte Adresse nur als
// Weiterleitung; Cockpit-Konten sehen hier niemals Inhalte.
export const Route = createFileRoute("/_cockpit/cockpit/meine-ausstattung")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/meine-ausstattung", replace: true });
  },
});
